import { Layout, LayoutErrorState } from './LayoutState';
import { RequestStateError } from 'communication/RequestState';
import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import { LayoutDto } from 'communication/types/uiConfiguration/LayoutDto';
import UIConfigurationDto from 'communication/types/uiConfiguration/UIConfigurationDto';
import {
    UIComponentConfiguration,
    UIConfiguration,
} from 'communication/types/uiConfiguration/UIConfiguration';
import { LayoutContainerShape } from './LayoutShape';
import { visit } from './store/reducer';
import { WidgetsSharedConfigState } from 'widgets/store/sharedConfiguration/WidgetsSharedConfigState';

export function mapFromUiConfigDto(
    uiConfigDto: UIConfigurationDto
): UIConfiguration {
    const layout: LayoutDto = JSON.parse(uiConfigDto.layout);
    sanitizeActiveIndexes(layout);
    return {
        name: uiConfigDto.layoutName,
        origin: uiConfigDto.origin,
        id: uiConfigDto.id,
        layout,
    };
}

export function mapToUiConfigDto(
    uiConfig: UIConfiguration
): UIConfigurationDto {
    return {
        id: uiConfig.id,
        layoutName: uiConfig.name,
        origin: uiConfig.origin,
        layout: JSON.stringify(uiConfig.layout),
    };
}

export function mapErrorResponse(
    layoutName: string,
    origin: string,
    error: RequestStateError
): LayoutErrorState {
    return { name: layoutName, origin, message: error.toString() };
}

export function mapToUIConfigFromState(
    layout: Layout,
    appSettings: AppSettingsState,
    components: { [key: string]: UIComponentConfiguration },
    sharedConfigs: WidgetsSharedConfigState
): UIConfiguration {
    const { id, name, origin, shape, version } = layout;

    const layoutDto: LayoutDto = {
        shape,
        components,
        appSettings,
        sharedWidgetConfigs: sharedConfigs,
        version: version ?? 0,
    };

    return {
        id,
        name,
        origin,
        layout: layoutDto,
    };
}

export function mapToLayoutFromUIConfig(uiConfig: UIConfiguration): Layout {
    return {
        id: uiConfig.id,
        name: uiConfig.name,
        origin: uiConfig.origin,
        shape: uiConfig.layout.shape,
        components: Object.keys(uiConfig.layout.components).map((k) => ({
            id: k,
            type: uiConfig.layout.components[k].type,
        })),
        activeInputId: undefined,
        version: uiConfig.layout.version,
    };
}

function sanitizeActiveIndexes(layout: LayoutDto) {
    visit(layout && layout.shape, (c) => {
        if (c.type === 'stack') {
            const stack = c as LayoutContainerShape;
            if (
                stack.activeItemIndex !== undefined &&
                stack.activeItemIndex > c.content.length - 1
            ) {
                stack.activeItemIndex =
                    c.content.length === 0 ? undefined : c.content.length - 1;
            }
        }
    });
}
